import React from "react";
import slide2 from "../assets/images/slide2.png";
import "./Society.css";
import Join from "./Join";

const Society = () => {
  return (
    <React.Fragment>
      <div className="container">
        <img src={slide2} className="mainStartHead" alt="" />
        <br />
        <p className="about-head">Computer Society</p>
        <br />
        <br />
        <p className="about-text">
          We Are the Home for Computer Science and Engineering Leaders The IEEE
          Computer Society is the premier source for information, inspiration,
          and collaboration in computer science and engineering. Connecting
          members worldwide, the Computer Society empowers the people who
          advance technology by delivering tools for individuals at all stages
          of their professional careers.
        </p>
        <p className="about-text">
          The IEEE Computer Society is the premier source for information,
          inspiration, and collaboration in computer science and engineering.
          Connecting members worldwide, the Computer Society empowers the people
          who advance technology by delivering tools for individuals at all
          stages of their professional careers. Our trusted resources include
          international conferences, peer-reviewed publications, a robust
          digital library, globally recognized standards, and continuous
          learning opportunities.
        </p>
        <p className="about-text">
          As the world’s top member organization dedicated to computer science
          and technology, the IEEE Computer Society advances the theory, design,
          practice, and application of computer and information-processing
          science and technology, as well as the professional standing of its
          members. Meet our leadership.
        </p>
        <p className="about-text">
          We strive to be the leading provider of technical information,
          community services, and personalized support to the world’s computer
          science and technology communities, as well as to celebrate the
          contributions of computer science and engineering professionals who
          develop new technologies and applications to improve the lives of
          people everywhere.
        </p>
        <p className="about-text">
          The IEEE Computer Society traces its origins back to 1946. For 75
          years, our members have played a central role in the rapid evolution
          of computer technologies, and we've grown from a small group of
          specialists to an international organization with more than 225,000
          individuals who are dedicated to advancing all aspects of computer
          science and engineering.
        </p>
        <br />
        <br />
        <p className="about-head2">Why join Us?</p>
        <br />
        <br />
        <p className="about-text">
          Benefit from world renowned research and award-winning magazines
          relevant to all computing professionals.
        </p>
        <p className="about-text">
          Get discounts to conferences and tap into mentorship programs, career
          development webinars, and more.
        </p>
        <p className="about-text">
          Join +50k professionals in computing and participate in professional
          chapters, share your research, and collaborate on the latest trends.
        </p>
        <p className="about-text">
          Spread inspiration and collaboration among the community by taking on
          a leadership position with the society.
        </p>
        <p className="about-text">
          Learn what’s new – and what’s next – with access to Computer Magazine.
          12x/year. Get deep discounts on magazine subscriptions without paying
          for full CSDL access.
        </p>
        <p className="about-text">
          18 complimentary articles per membership year from the most trusted
          source in computing.
        </p>
        <p className="about-text">
          IEEE’s flagship publication available to those that also belong to
          both IEEE and IEEE CS.
        </p>
        <p className="about-text">
          Save $350 on publishing papers with your IEEE Computer Society
          Membership.Access the premier collection of technical periodicals and
          conference papers.
        </p>
        <p className="about-text">
          INCLUDED with student membership.Curating highly relevant news and
          research from across the CS publications in a single source.Create the
          text, graphics, and supplementary files needed for your IEEE CS
          journal article.
        </p>
        <p className="about-text">
          Elevate your professional image and expand your global network by
          engaging with other IEEE YPs.Join us in spreading Diversity &
          Inclusion to computing research for a bigger impact.Member-exclusive
          awards recognize members’ positive impacts in the workplace and
          community.Commit to your profession by becoming an IEEE Fellow. A
          distinction reserved for 1% of members.Special discounts on membership
          are available to those with special financial circumstances.Strenghten
          your leadership by taking on progressively more responsibility in
          local activities.Engage with members and share the depth of your
          knowledge by becoming Distinguished Speaker.Contribute our knowledge
          to the future of your industry by leading a Technical Committee.Begin
          your road to achieving to IEEE Fellow by elevating to IEEE Senior
          member.
        </p>
        <p className="about-text">
          Connect with others who share your interests through your local
          chapter.Connect with other computing students and build the skills you
          need to enter the workforce.Meet other IEEE members with different
          interests in your geographic area.Join a group that’s right for you
          and share technical knowledge and professional experiences.Join an
          international network of professionals creating the latest advances in
          their field.Network, collaborate, and create — all in one central hub.
        </p>
        <p className="about-text">
          The perfect platform to exchange ideas and learn about the latest
          innovations in technology.Providing a dynamic platform for members to
          learn, collaborate, and create lasting connections.Increase your
          network and improve your business skills like budgeting, contract
          negotiations.Connect today with the premier conference publishing and
          production team for STEM conferences.
        </p>
        <p className="about-text">
          Find entrepreneurship resources like pitch competitions, incubators,
          accelerators, and grants.Access to discounts for various Liberty
          Mutual insurance programs.Access life & supplemental health insurance
          plans. US, parts of CAN, and PR IEEE members only.Special events are
          made available to members for free. Keep an eye out for our emails!
        </p>
        <br />
        <br />
        <Join />
        <br />
        <br />
      </div>
    </React.Fragment>
  );
};

export default Society;
